import { useCallback } from "react";

import { useTranslation } from "@/lib/i18n";
import { useDashboardData } from "@/features/shared/hooks";
import { AdditionalWidgetData } from "@/types/additional-widget-data";
import { TimeSeriesTable } from "@/features/shared/widgets/components";
import useRefetchWidget from "@/features/shared/widgets/hooks/useRefetchWidget";
import {
  formatSeichesCellValue,
  formatSeichesTooltip,
  getSeichesColorCodeForValue,
} from "@/features/shared/widgets/seiches/seiches-display.utils";

type Props = {
  id: string;
  data: AdditionalWidgetData;
};

const Seiches = ({ id, data }: Props) => {
  const { selectedTimeRange: timeRange } = useDashboardData();
  const { t } = useTranslation();

  useRefetchWidget(id);

  const formatValue = useCallback((value: number) => formatSeichesCellValue(value, t), [t]);
  const formatTooltip = useCallback((value: number) => formatSeichesTooltip(value, t), [t]);

  return (
    <TimeSeriesTable
      series={data.data}
      timeRange={timeRange}
      valueRenderer={formatValue}
      getTooltip={(_value, _serie, _date) => formatTooltip(_value)}
      getColorCodeForValue={getSeichesColorCodeForValue}
    />
  );
};

export default Seiches;
